import Api from '../../api'
import { all, takeLatest, call, put } from 'redux-saga/effects'
import createRequestSaga, {
  handleResponseError,
} from 'portal-modules/common/redux/create-request-saga'
import { addCustomContent } from 'portal-modules/common/redux/modules/customContent'
import { requestUpcomingReservationsList } from './upcomingReservations'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'

// action types
export const REQUEST_AMENITIES_LIST = 'ep/amenities/REQUEST_AMENITIES_LIST'
export const RECEIVE_AMENITY_LIST = 'ep/amenities/RECEIVE_AMENITY_LIST'
export const SAVE_AMENITY_RESERVATION = 'ep/amenities/SAVE_AMENITY_RESERVATION'
export const SAVE_INTERNATIONAL_AMENITY_RESERVATION =
  'ep/amenities/SAVE_INTERNATIONAL_AMENITY_RESERVATION'
export const REQUEST_AMENITY_AMOUNT = 'ep/amenities/REQUEST_AMENITY_AMOUNT'

// action creators
export const requestAmenitiesList = () => ({
  type: REQUEST_AMENITIES_LIST,
})

export const requestSaveAmenityReservation = (payload, callback) => ({
  type: SAVE_AMENITY_RESERVATION,
  payload,
  callback,
})

export const requestAmenityAmount = (payload, callback) => ({
  type: REQUEST_AMENITY_AMOUNT,
  payload,
  callback,
})

export const requestSaveInternationalAmenityReservation = (
  payload,
  callback,
) => ({
  type: SAVE_INTERNATIONAL_AMENITY_RESERVATION,
  payload,
  callback,
})

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_AMENITY_LIST:
      return { ...state, ...payload }
    default:
      return state
  }
}

// sagas
export function* getAmenitiesList() {
  try {
    const { amenities, settings } = yield call(Api.requestAmenities)

    if (amenities && amenities.length) {
      let actions = []
      actions.push({
        type: RECEIVE_AMENITY_LIST,
        payload: amenities.reduce(
          (obj, currentVal) => ({
            ...obj,
            [currentVal.id]: {
              ...currentVal,
              max_hours:
                !currentVal.reserve_by_day && currentVal.max_hours === 0
                  ? 24
                  : currentVal.max_hours,
            },
          }),
          {},
        ),
      })

      if (Object.keys(settings).length) {
        actions.push(addCustomContent({ amenities: settings.custom_text }))
      }

      yield all(actions.map(a => put(a)))
    }
  } catch (error) {
    console.error('🔍 Error in getAmenitiesList saga:', error)
  }
}

export function* watchRequestAmenities() {
  yield takeLatest(
    REQUEST_AMENITIES_LIST,
    createRequestSaga(getAmenitiesList, {
      key: 'amenities',
      message: __('Getting Amenities'),
    }),
  )
}

export function* saveAmenityReservation({ payload, callback }) {
  const { reservation } = yield call(Api.saveAmenityReservation, payload)
  if (reservation) {
    yield put(requestUpcomingReservationsList())
    yield put(requestAmenitiesList())
    if (typeof callback === 'function') {
      callback()
    }
  }
}

export function* fetchAmenityAmount({ payload, callback }) {
  const rate = yield call(Api.getReservationAmount, payload)
  typeof callback === 'function' && callback(rate)
}

export function* saveInternationalAmenityReservation({ payload, callback }) {
  const { reservation } = yield call(
    Api.saveInternationalAmenityReservation,
    payload,
  )
  if (reservation) {
    yield put(requestUpcomingReservationsList())
    yield put(requestAmenitiesList())
    if (typeof callback === 'function') {
      callback()
    }
  }
}
export function* handleAmenityError(err) {
  const newErr = {
    ...err,
    fields: [ err?.fields || [] ],
  }
  const key = getEmbeddedViewFlag() ? 'apex_payments' : 'payments';
  yield call(handleResponseError, newErr, { key });

}

export function* watchSaveAmenityReservation() {
  yield takeLatest(
    SAVE_AMENITY_RESERVATION,
    createRequestSaga(saveAmenityReservation, {
      key: 'amenities',
      message: __('Processing reservation'),
      successMessage: __('Booking Successful'),
      write: true,
      onError: handleAmenityError,
    }),
  )
}

export function* watchAmenityAmount() {
  yield takeLatest(
    REQUEST_AMENITY_AMOUNT,
    createRequestSaga(fetchAmenityAmount, {
      key: 'amenities',
      message: __('Fetching amount'),
      successMessage: __('Fetched Successful'),
      write: true,
      onError: handleAmenityError,
    }),
  )
}

export function* watchSaveInternationalAmenityReservation() {
  yield takeLatest(
    SAVE_INTERNATIONAL_AMENITY_RESERVATION,
    createRequestSaga(saveInternationalAmenityReservation, {
      key: 'amenities',
      message: __('Processing reservation'),
      successMessage: __('Reservation Completed'),
      write: true,
      onError: handleAmenityError,
    }),
  )
}

export const sagas = [
  watchRequestAmenities,
  watchSaveAmenityReservation,
  watchAmenityAmount,
  watchSaveInternationalAmenityReservation,
]
